import { type ApiClientResponse, apiClient, routes } from 'common/services';

type ChangeRoleRequestData = {
  data: Array<{
    entity_ids: string[];
    entity_type: 'Community';
    roles: string[];
    user_id: string;
  }>;
};

export const changeRoleInCommunity = async (params: ChangeRoleRequestData) =>
  apiClient.patch<undefined, ApiClientResponse<undefined>>(routes.community.changeRole, params);
